export const paisesAutocomplete = [
  "AR",
  "BO",
  "BR",
  "CL",
  "CO",
  "CR",
  "CU",
  "EC",
  "SV",
  "US",
  "GT",
  "HT",
  "HN",
  "MX",
  "NI",
  "PA",
  "PY",
  "PE",
  "DO",
  "UY",
  "VE",
  "OTRO",
];
